import React, { useMemo } from "react";

// Fases principales del proyecto
const mainStages = [
  { key: "PLANEACIÓN", label: "Planeación" },
  { key: "EJECUCIÓN", label: "Ejecución" },
  { key: "CIERRE", label: "En Cierre" },
  //{ key: 'CERRADO', label: 'Cerrado' }
];

const TimelineProjectStatus = ({ phasesData }) => {
  // 1--> Modelado: extraer solo PLANEACIÓN, EJECUCIÓN y CIERRE
  const modeledData = useMemo(
    () =>
      phasesData.map(({ id, parentId, title, start, end, progress }) => ({
        id,
        parentId,
        title,
        start,
        end,
        progress,
      })),
    [phasesData]
  );

  // 2--> para cada fase principal, calculamos start=min(hijos.start sino tiene entonces la propia) y end=max(hijos.end)
  const stages = useMemo(
    () =>
      mainStages.map((stage) => {
        // la fila que corresponde a la fase en sí
        const phase = modeledData.find((p) => p.title === stage.key);

        if (!phase) {
          // si no la encontramos, devolvemos la fase vacía
          return { ...stage, start: null, end: null, progress: 0 };
        }

        // buscamos todos los hijos de esa fase
        const children = modeledData.filter((p) => p.parentId === phase.id);

        // convertimos a Date y obtenemos min/max
        const allStarts = children.length
          ? children.map((c) => new Date(c.start))
          : [new Date(phase.start)];
        const allEnds = children.length
          ? children.map((c) => new Date(c.end))
          : [new Date(phase.end)];

        const minStart = new Date(Math.min(...allStarts));
        const maxEnd = new Date(Math.max(...allEnds));

        // formateamos como ISO string para luego formatear en pantalla
        const computedStart = minStart.toISOString();
        const computedEnd = maxEnd.toISOString();

        return {
          ...stage,
          start: computedStart,
          end: computedEnd,
          progress: phase.progress ?? 0,
        };
      }),
    [modeledData]
  );

  const formatDate = (iso) => {
    if (!iso) return "";
    const date = new Date(iso);
    return date.toLocaleDateString("es-CO", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  };

  if (!stages.length) {
    return <div>No hay información del estado del proyecto.</div>;
  }

  return (
    <div className="timeline-container">
      {stages.map((stage, idx) => {
        const isCompleted = stage.progress === 100;
        const isPending = stage.progress === 0;
        const isInProgress = !isPending && !isCompleted;

        const stateClass = isCompleted
          ? "state-circle completed"
          : isInProgress
          ? "state-circle current"
          : "state-circle pending";

        const statusLabel = isCompleted
          ? "Completado"
          : isInProgress
          ? "En curso"
          : "Pendiente";

        return (
          <React.Fragment key={stage.key}>
            <div className="state-container">
              <div className="state-name">{stage.label}</div>
              <div className={stateClass}>
                {stage.progress > 0 ? `${stage.progress}%` : "0%"}
              </div>
              <div className="date-label">
                <div className="date-item">
                  <i className="fa fa-play mr-2 text-secondary"></i>
                  {formatDate(stage.start)}
                </div>
                <div className="date-item">
                  <i className="fa fa-flag-checkered mr-2 text-secondary"></i>
                  {formatDate(stage.end)}
                </div>
              </div>
              <div className="status-label">{statusLabel}</div>
            </div>
            {idx < stages.length - 1 && (
              <div className="arrow-container">
                <i className="bi bi-arrow-right-short arrow-icon fw-bold text-primary"></i>
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default TimelineProjectStatus;
